"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// iui-utils

/* ++++++++++ --------------- EXPORT : COLOR PICKER --------------- ++++++++++ */


var _default = {
  colorpicker: {
    width: (0, _index.pxToEm)(352),
    height: (0, _index.pxToEm)(80),
    marginRight: (0, _index.pxToEm)(8),
    position: 'relative',
    '& .colorpickerlabel': {
      fontSize: (0, _index.pxToEm)(14),
      marginBottom: (0, _index.pxToEm)(8),
      fontWeight: '500',
      height: (0, _index.pxToEm)(24),
      width: '272px',
      display: function display(props) {
        return !!props.label ? 'flex' : 'none';
      },
      '& span': {
        lineHeight: (0, _index.pxToEm)(24)
      },
      '& .reset': {
        marginRight: (0, _index.pxToEm)(8),
        marginLeft: 'auto',
        width: '40px',
        height: '24px',
        color: 'rgb(20, 148, 244)',
        fontSize: '14px',
        fontFamily: 'Work Sans',
        fontWeight: '500',
        textAlign: 'right',
        lineHeight: '24px',
        float: 'right',
        cursor: 'pointer'
      }
    },
    // .... CURRENT COLOR ..... //
    '& .currentcolor': {
      display: 'flex',
      alignItems: 'center',
      '& .swatch': {
        borderRadius: (0, _index.pxToEm)(24),
        cursor: 'pointer',
        width: (0, _index.pxToEm)(48),
        height: (0, _index.pxToEm)(48),
        marginRight: (0, _index.pxToEm)(3),
        border: '2px solid rgb(238, 242, 246)'
      },
      '& .colortext': {
        fontSize: (0, _index.pxToEm)(16),
        fontWeight: '500',
        color: _index.theme.color.supporting.dark.swatch,
        fontFamily: 'Work Sans',
        lineHeight: (0, _index.pxToEm)(20),
        textTransform: 'uppercase'
      },
      '& .field': {
        width: (0, _index.pxToEm)(216),
        marginRight: (0, _index.pxToEm)(8),
        '& .formelement': {
          height: (0, _index.pxToEm)(48),
          width: '100%',
          border: '2px solid rgb(238, 242, 246)',
          alignItems: 'center'
        }
      },
      '& .invalidColor': {
        width: '72px',
        height: '28px',
        color: 'rgb(223, 29, 29)',
        fontSize: '12px',
        fontFamily: 'Work Sans',
        fontWeight: '500',
        lineHeight: '14px',
        alignContent: 'center'
      }
    },
    // ..... COLOR PICKER ..... //
    '& .picker': {
      opacity: '0',
      position: 'absolute',
      left: '0',
      top: '75px',
      zIndex: '-1',
      marginTop: (0, _index.pxToEm)(8),
      transform: 'translateY(-200%)',
      // done so we don't have any clickable invisible hotspots on the page
      '&.active': {
        animationDuration: '.3s',
        animationFillMode: 'forwards',
        animationName: 'fadeInLeft',
        animationDelay: '0s',
        zIndex: '3'
      },
      '&.inactive': {
        display: 'none'
      },
      '& .name-close': {
        width: '100%'
      },
      '& .button': {
        boxShadow: 'rgb(0 0 0 / 30%) 0px 0px 2px, rgb(0 0 0 / 30%) 0px 4px 8px',
        borderRadius: '0px 0px 5px 5px'
      },
      '& .chrome-picker': {
        //width: `${pxToEm(300)} !important`,
        borderRadius: '0 !important',
        '& div:last-child > div:last-child > div:last-child': {
          display: 'none'
        },
        '& .saturation-white': {
          '& div:last-child': {
            display: 'block !important'
          }
        }
      }
    }
  }
};
exports.default = _default;